import React, { PureComponent } from "react";
import { Row, Col } from "reactstrap";
import VerbodenGameLayout from "../../../components/verbodenGameLayout";
import LeadPlayer from "./leadPlayer";
import VsPlayer from "./vsPlayers";
import { connect } from "react-redux";
import { withSocket } from "../../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { Redirect } from "react-router-dom";
import _ from "lodash";

import { motion, AnimatePresence } from "framer-motion";
import { fadeDelayVariants } from "../../../components/shared/utils/animations";

class Result extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      quarterback: "",
      currentTeam: "",
      guessedWords_A: [],
      guessedWords_B: [],
      buzzledWords_A: [],
      buzzledWords_B: [],
      skippedWords_A: [],
      skippedWords_B: []
    };
  }
  componentDidMount() {
    let roomData = this.props.gameReducer.roomObj;
    let guessedWordsA,
      skippedWordsA,
      buzzledWordsA,
      guessedWordsB,
      skippedWordsB,
      buzzledWordsB = [];
    if (roomData.game_state) {
      const gameState = roomData.game_state;
      guessedWordsA = gameState.right_words_a;
      skippedWordsA = gameState.skipped_words_a;
      buzzledWordsA = gameState.missed_words_a;
      guessedWordsB = gameState.right_words_b;
      skippedWordsB = gameState.skipped_words_b;
      buzzledWordsB = gameState.missed_words_b;
    }
    this.setState({
      skippedWords_A: skippedWordsA,
      skippedWords_B: skippedWordsB,
      buzzledWords_A: buzzledWordsA,
      buzzledWords_B: buzzledWordsB,
      guessedWords_A: guessedWordsA,
      guessedWords_B: guessedWordsB
    });
  }

  render() {
    let roomData = this.props.gameReducer.roomObj;
    let statusOfGame = "";
    const gS = roomData && roomData.game_state;
    if (gS && gS.status) {
      statusOfGame = gS.status;
    }
    const roomUsers = roomData ? roomData.users : [];
    let teamAQB = {},
      teamBQB = {};
    if (gS && gS.teams[0] && gS.teams[0].quarterback) {
      teamAQB = roomUsers.find(
        (user) => user.player_id === gS.teams[0].quarterback
      );
    }
    if (gS && gS.teams[1] && gS.teams[1].quarterback) {
      teamBQB = roomUsers.find(
        (user) => user.player_id === gS.teams[1].quarterback
      );
    }

    if (statusOfGame === "PreGuess" || statusOfGame === "Guessing") {
      return <Redirect to={"/verboden/play"} />;
    }
    if (statusOfGame === "Over") {
      return <Redirect to={"/verboden/final"} />;
    }
    const {
      buzzledWords_A,
      buzzledWords_B,
      skippedWords_B,
      skippedWords_A,
      guessedWords_A,
      guessedWords_B
    } = this.state;
    return (
      <VerbodenGameLayout>
        <div key="vb_3" className="verboden-game-play p-20 results-wrapper">
          <div>
            <AnimatePresence exitBeforeEnter>
              <motion.div
                key="vb_results_text"
                variants={fadeDelayVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <h1 className="text-orange mb-3">ROUND RESULTS</h1>
              </motion.div>
            </AnimatePresence>
            <Row className="mb-3 LeadPlayerRow">
              <Col className="LeadPlayerColLeft">
                <LeadPlayer
                  team={"Team A"}
                  quaterBack={teamAQB}
                  skippedWords={skippedWords_A}
                  guessedWords={guessedWords_A}
                  buzzledWords={buzzledWords_A}
                />
              </Col>
              <Col className="LeadPlayerColRight">
                <LeadPlayer
                  team={"Team B"}
                  quaterBack={teamBQB}
                  skippedWords={skippedWords_B}
                  guessedWords={guessedWords_B}
                  lastTeam={true}
                  buzzledWords={buzzledWords_B}
                />
              </Col>
            </Row>
          </div>

          <VsPlayer
            skippedWords_A={skippedWords_A}
            skippedWords_B={skippedWords_B}
            guessedWords_A={guessedWords_A}
            guessedWords_B={guessedWords_B}
            buzzledWords_A={buzzledWords_A}
            buzzledWords_B={buzzledWords_B}
          />
        </div>
      </VerbodenGameLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
  game3Reducer: state.game3Reducer
});

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, null)
)(Result);
